import React, {Component} from "react";
import {message, Popconfirm} from "antd";
import DescriptionList from "@comm/DescriptionList";
import {queryUpdateFinancingStatus} from "@api/incubator/customBase";
import CustomTag from "./CustomTag";

const { Description } = DescriptionList;

class CardBase extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {}

  submitEdit = () => {
    queryUpdateFinancingStatus({
      customUuid: this.props.params.customUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.refresh();
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { customInfo } = this.props;
    return (
      <div>
        <DescriptionList size="large" col={3}>
          <Description term="公司名称">{customInfo.customName}</Description>
          <Description term="公司联系人">{customInfo.contactName}</Description>
          <Description term="联系电话">{customInfo.contactTel}</Description>
          <Description term="公司法人">{customInfo.legalName}</Description>
          <Description term="法人联系方式">{customInfo.legalTel}</Description>
          <Description term="是否融资">
            <span>
              <span>{customInfo.isFinancing === 0 ? "否" : "是"}</span>
              {customInfo.isFinancing === 0 ? (
                <Popconfirm
                  title="确认更新融资状态吗？"
                  onConfirm={this.submitEdit}
                >
                  <a style={{ paddingLeft: "8px" }}>修改</a>
                </Popconfirm>
              ) : null}
            </span>
          </Description>
        </DescriptionList>
        <DescriptionList size="large" col={1}>
          <Description term="公司标签">
            <CustomTag {...this.props} />
          </Description>
        </DescriptionList>
      </div>
    );
  }
}
export default CardBase;



// WEBPACK FOOTER //
// ./src/components/incubator/custom/base/CardBase.js